import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import _ from 'lodash';

import CardHolder from 'app/components/CardHolder';

import { generatePath, useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { fetchRequests, clearRequests, updateRequestDetails } from 'app/store/slices/requests';
import { CircularProgress } from '@material-ui/core';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { updateServiceDetails } from 'app/store/slices/services';
import helpers from 'app/utils/helpers';
import Filter from '../Filter';
import {
  SERVICES_CODES,
  SERVICES_GROUPS,
  SERVICES_PROPERTIES,
} from 'app/config/services';
import { STATUS_CODES, STATUS_COLORS } from 'app/config/status';
import { URLS } from 'app/config/urls';

import styles from './styles';
const useStyles = makeStyles(styles);

function Requests(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loadingRequests, setLoadingRequests] = useState(true);

  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState({});
  // const [emptyRows, setEmptyRows] = useState(0);

  const [rows, setRows] = useState([]);
  const { intl } = props;

  const user = useSelector(state => state.auth.user);
  const requests = useSelector(state => state.requests.requests);
  const licenseChangeTypes = useSelector(state => state.license.licenseChangeTypes);

  // useEffect(() => {
  //   if (requests.content) {
  //     const numResults = requests.content.length;
  //     setEmptyRows(pageSize - Math.min(pageSize, numResults - page * pageSize));
  //   }
  // },[page, pageSize, requests.content]);

  const btnNewRequestDisable = useMemo(() => {
    if (user?.boAtivo) {
      return false;
    }
    if (requests && requests.content && requests.content.length > 0) {
      let status = false;
      const found = _.find(
        requests.content,
        req =>
          req.cdServico !== SERVICES_CODES.ACESSO_PORTAL_FISICA &&
          req.cdServico !== SERVICES_CODES.ACESSO_PORTAL_JURIDICA
      );

      requests.content.forEach(req => {
        if (found) return;
        if (
          (req.cdServico === SERVICES_CODES.ACESSO_PORTAL_FISICA ||
            req.cdServico === SERVICES_CODES.ACESSO_PORTAL_JURIDICA) &&
          req.cdSituacao !== STATUS_CODES.CANCELADO &&
          req.cdSituacao !== STATUS_CODES.REPROVADO
        ) {
          status = true;
        }
      });

      return status;
    }
    return !user?.boAtivo;
  }, [requests, user]);

  const handleOptions = () => {
    if (!btnNewRequestDisable) {
      history.push(generatePath(URLS.SERVICES));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearRequests());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [title, setTitle] = useState(
    intl.formatMessage({ id: 'LABELS.MENU.LATEST_SERVICES.TITLE' })
  );

  useEffect(() => {
    if (!requests.content || requests.content.length === 0) {
      setTitle(intl.formatMessage({ id: 'LABELS.MENU.NO_SERVICES.TITLE' }));
    } else {
      setTitle(intl.formatMessage({ id: 'LABELS.MENU.LATEST_SERVICES.TITLE' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests]);

  const columns = [
    {
      title: '',
      field: 'code',
    },
    { title: '', field: 'request' },
    { title: '', field: 'status' },
    {
      title: '',
      field: 'action',
      headerStyle: {
        maxWidth: '50px',
      },
      cellStyle: {
        textAlign: 'right',
        width: '100%',
        maxWidth: '50px',
      },
    },
  ];

  const findRequests = useCallback(
    async filtersParam => {
      setLoadingRequests(true);
      try {
        const aditionalFilters = {};
        if (filtersParam) {
          if (filtersParam.nuSolicitacaoFmt)
            aditionalFilters.nuSolicitacaoFmt = filtersParam.nuSolicitacaoFmt;
          if (filtersParam.dtPeriodoInicial)
            aditionalFilters.dtPeriodoInicial = filtersParam.dtPeriodoInicial;
          if (filtersParam.dtPeriodoFinal)
            aditionalFilters.dtPeriodoFinal = filtersParam.dtPeriodoFinal;
          if (filtersParam.cdServico)
            aditionalFilters.servicos = [{ cdServico: Number(filtersParam.cdServico) }];
        }
        await dispatch(fetchRequests({ page, size: pageSize, ...aditionalFilters }));
        setLoadingRequests(false);
      } catch (error) {
        setLoadingRequests(false);
      }
    },
    [dispatch, page, pageSize]
  );

  useEffect(() => {
    findRequests();
  }, [findRequests]);

  useEffect(() => {
    const prepareData = content => {
      let subtitle = null;
      const json = content.jsonSolicitacao ? JSON.parse(content.jsonSolicitacao) : {};
      if (SERVICES_GROUPS.LICENSE.includes(content.cdServico) && json.cdTipoAlteracaoLicenca) {
        const found = licenseChangeTypes.filter(lt => lt.cdTipoAlteracaoLicenca === Number(json.cdTipoAlteracaoLicenca));
        if(found && found[0]){
          subtitle = found[0].deTipoAlteracaoLicenca;
        }
      }

      return {
        originalData: content,
        code: content.nuSolicitacaoFmt,
        request: (
          <>
            <div className={classes.title}>
              {content.servico?.nmServico}
              {subtitle && (
                <>
                  <br />
                  {subtitle}
                </>
              )}
            </div>
            <div className={classes.date}>{helpers.formatarData(content.dtCadastro, true)}</div>
          </>
        ),
        status: (
          <>
            <div
              className={classes.status}
              style={{
                color: `${STATUS_COLORS[content.situacao?.cdSituacao]?.color}`,
              }}
            >
              {content.situacao?.deSituacao}
            </div>
          </>
        ),
        action: <MoreHorizIcon color="primary" className={classes.btnAction} />,
      };
    };

    const rows = [];
    if (requests.content) {
      requests.content.forEach(cont => {
        rows.push(prepareData(cont));
      });
    }
    setRows(rows);
    setPagination(requests);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests]);

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClick = (e, v) => {
    if (v?.originalData?.servico) {
      dispatch(updateRequestDetails(v.originalData));
      dispatch(updateServiceDetails(v.originalData.servico));
      let url = SERVICES_PROPERTIES[v.originalData.servico.cdServico].url;
      if (v.originalData.servico.cdServico === SERVICES_CODES.VISTORIA) {
        if (user?.boVistoriador) {
          url = URLS.INSPECTION_REPORT;
        }
      }
      history.push(`${url}`);
    }
  };

  const handleSendFilter = cleaning => {
    if (cleaning) findRequests();
    if (!cleaning && Object.keys(filters).length > 0) {
      findRequests(filters);
    }
    setOpenFilter(false);
  };

  return (
    <>
      <Filter
        open={openFilter}
        filters={filters}
        setFilters={setFilters}
        onClose={() => setOpenFilter(false)}
        sendFilter={handleSendFilter}
        hasNuSolicitacao={true}
        hasTpServico={true}
        hasDtPeriodoInicial={true}
        hasDtPeriodoFinal={true}
      />
      <CardHolder
        title={title}
        classes={{ content: classes.card }}
        labelName={intl.formatMessage({ id: 'LABELS.MENU.NEW_SERVICES.TITLE' })}
        handleOptions={handleOptions}
        disableBtnOptions={btnNewRequestDisable}
        labelSearch={intl.formatMessage({ id: 'LABELS.COMMONS.SEARCH' })}
        handleFilter={() => setOpenFilter(true)}
      >
        <div className={classes.internalContainer}>
          {loadingRequests && (
            <div className={classes.centerProgress}>
              <CircularProgress size={20} />
            </div>
          )}
          {!loadingRequests && (
            <>
              {rows.length > 0 && (
                <div style={{ overflow: 'auto' }}>
                  <CustomPaginationActionsTable
                    columns={columns}
                    rows={rows}
                    // emptyRows={emptyRows}
                    hideHeader={true}
                    hideFilterOrder={true}
                    placeholderSearch="Busca"
                    pagination={pagination}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    onClickRow={(e, v) => handleClick(e, v)}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </CardHolder>
    </>
  );
}

export default injectIntl(Requests);
